import t from '@zenlayer/zen-intl18';
export var jobTitles = [{
  value: 'CEO/COO/VP/General Manager',
  label: t('BaOqlaPRDAVw')
}, {
  value: 'Channel/Partner/Sales/BD Manager',
  label: t('JgqP4M8SgPMA')
}, {
  value: 'Marketing/Brand/Campaign Manager',
  label: t('UYOjahun5PTj')
}, {
  value: 'Sales/Account Manager/Business Consultant',
  label: t('JUJn9VY3bHSa')
}, {
  value: 'Solution Architect/IT/Support Engineer/PM',
  label: t('pulNYRMAucCg')
}, {
  value: 'Finance/Legal Counsel/Compliance Officer',
  label: t('xFdZVUuxYUYl')
}, {
  value: 'Individual',
  label: t('hN8loT653UUY')
}, {
  value: 'Other',
  label: t('rNYj1Xlv9Zwv')
}];